import React, { Component } from "react";
import PropTypes from "prop-types";
import FormGroupStyled from "./FormGroup.styled";

export default class FormGroup extends Component {
    render() {
        // destructuring props
        const { children, classes, focused, error, disabled, covert } = this.props;
        return (
            <FormGroupStyled focused={focused} error={error} disabled={disabled} className={classes} covert={covert}>
                {children}
            </FormGroupStyled>
        );
    }
}

// props validation
FormGroup.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.string,
    focused: PropTypes.bool,
    error: PropTypes.string,
    disabled: PropTypes.bool,
    covert: PropTypes.bool
};
